import { createFileRoute } from "@tanstack/react-router";
import { Step1BusinessInfo } from "@/features/vendor/onboarding/v1/step-1-business-info";

export const Route = createFileRoute(
  "/vendors/onboarding/v1/step-1-business-info",
)({
  component: Step1BusinessInfo,
});
